import { useTranslation } from "react-i18next";

import { Dialog } from 'primereact/dialog';

export default function Bac({visible, setVisible}) {

    const { t } = useTranslation();

    return(
        <Dialog header={t("bac")} visible={visible} style={{ width: '50vw' }} onHide={() => {if (!visible) return; setVisible(false); }} className="bacPanel">
            <p className="m-0">
                {t("bacDetails")}
            </p>
        </Dialog>
    )
}